import React from 'react';
import SocialLinks from '../SocialLinks/SocialLinks';
import './Intro.css';
import Pic from '../../images/man-working-with-laptop-vector-3313441.jpg';

const Intro = () => {
    return (
        <section id='intro' className='pt-24 flex py-5 flex-col lg:px-12 px-6 lg:flex-row-reverse items-center mx-auto'>
            <div data-aos="fade-up" className='w-full lg:w-1/2'>
                <img className='w-full mx-auto' src={Pic} alt="" />
            </div>
            <div data-aos="fade-down" className='w-full lg:w-1/2'>
                <h1 className='text-xl font-bold'>WELCOME TO MY WORLD!</h1>
                <h3 className="text-3xl py-3">I'm a <span className='text-primary'>Front-end Developer</span></h3>
                <SocialLinks />
                <p className='text-justify'>Hello there! I am a Sourav Saha. A Fresh engineering undergraduate, software enthusiast, and diligent person who is actively searching for practical knowledge to get adapted to the ever-changing modern technologies and obtain experience in the technological field.</p>

                <div className='flex gap-5'>

                    <a href="Sourav Saha - Resume.pdf" download="Sourav Saha - Resume.pdf" className="mt-5 button-link bg-secondary my-btn uppercase text-white font-bold text-center">Download Resume</a>
                    <a href='#about' className="mt-5 button-link bg-secondary my-btn uppercase text-white font-bold text-center">About Me</a>
                </div>
            </div>
        </section>
    );
};

export default Intro;